export interface Banner {
  id: number;
  title: string;
  sortOrder: number;
  isActive: boolean;
  linkUrl: string;
  image: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export const bannerFromResponse = (responseData: any): Banner => ({
  id: responseData.id,
  title: responseData.title,
  sortOrder: responseData.sort_order,
  isActive: responseData.is_active,
  linkUrl: responseData.link_url,
  image: responseData.image,
  description: responseData.description,
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});
